<template>
  <div class="personal-page">
    <!-- 用户信息 -->
    <div class="user-info flex-rowl">
      <div class="user-tx" @click="handleClickUpload">
        <van-image
          class="img"
          width="100%"
          height="100%"
          fit="cover"
          round
          :src="
            USERINFO.headimg
              ? USERINFO.headimg
              : require('../assets/images/user-tx.png')
          "
        />
        <div class="edit-icon flex-rowc"></div>
        <input
          ref="imageInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="handleFileChange"
        />
      </div>
      <div class="user-details">
        <div class="user-name flex-between">
          <h2>{{ USERINFO.truename ? USERINFO.truename : "" }}</h2>
          <div class="edit-button" @click="handleEditUser"></div>
        </div>
        <!-- 用户等级 -->
        <div class="user-level-job-number flex-rowl">
          <div class="level flex-rowl">
            <p>{{ USERINFO.levelid ? "LV-" + USERINFO.levelid : "" }}</p>
            <p>|</p>
            <p>{{ USERINFO.attrname ? USERINFO.attrname : "" }}</p>
          </div>
          <div class="job-number flex-rowl">
            <p>工号:{{ USERINFO.accountid ? USERINFO.accountid : "" }}</p>
            <div
              class="copy_box"
              :data-clipboard-text="USERINFO.accountid"
              @click="handleCopyBtn"
            ></div>
          </div>
        </div>
        <!-- 用户认证 -->
        <div class="user-verification flex-rowl" @click="handleToast">
          <div class="txt flex-rowl disabled">已认证</div>
          <div class="verify-button flex-rowc"></div>
        </div>
      </div>
    </div>
    <!-- 用户认证信息 -->
    <div class="user-verification-info">
      <h1>用户认证信息：</h1>
      <div class="user-verification-list">
        <div class="user-verification-item flex-rowl">
          <i class="icon name-icon"></i>
          <div class="info flex-rowl">
            <h2>姓<span>占位</span>名:</h2>
            <p>{{ USERINFO.truename }}</p>
          </div>
        </div>
        <div class="user-verification-item flex-rowl">
          <i class="icon tel-icon"></i>
          <div class="info flex-rowl">
            <h2>手<span>占位</span>机:</h2>
            <p>{{ USERINFO.mobile }}</p>
          </div>
        </div>
        <!-- <div class="user-verification-item flex-rowl">
          <i class="icon weixin-icon"></i>
          <div class="info flex-rowl">
            <h2>工作微信:</h2>
            <p>{{ USERINFO.tuozhan[0].weixin }}</p>
          </div>
        </div> -->
        <div class="user-verification-item flex-rowl">
          <i class="icon sex-icon"></i>
          <div class="info flex-rowl">
            <h2>性<span>占位</span>别:</h2>
            <p>{{ USERINFO.sex ? USERINFO.sex : "" }}</p>
          </div>
        </div>
        <div class="user-verification-item flex-rowl">
          <i class="icon age-icon"></i>
          <div class="info flex-rowl">
            <h2>年<span>占位</span>龄:</h2>
            <p>{{ USERINFO.age ? USERINFO.age : "" }}</p>
          </div>
        </div>
        <div class="user-verification-item flex-rowl">
          <i class="icon address-icon"></i>
          <div class="info">
            <h2>所在地区:</h2>
            <div class="txt">
              <p>
                <span v-if="USERINFO.provincename"
                  >{{ USERINFO.provincename }}、</span
                >
                <span v-if="USERINFO.cityname">{{ USERINFO.cityname }}、</span>
                <span v-if="USERINFO.areaname">{{ USERINFO.areaname }}</span>
              </p>
              <p>{{ USERINFO.addr ? USERINFO.addr : "区、街道、详细地址" }}</p>
              <!-- <input type="text" v-model="PCA_address" placeholder="省、市、自治区">
              <input type="text" v-model="USERINFO.addr" placeholder="区、街道、详细地址"> -->
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 功能列表 -->
    <div class="function-list">
      <div class="function-item flex-rowc" @click="handleEditUser">
        <p>个人信息管理</p>
      </div>
      <div class="function-item flex-rowc" @click="handleToast">
        <div class="business-icon icon">
          <img src="../assets/images/business-icon.png" alt="" />
        </div>
        <p>业务绩效</p>
      </div>
      <div class="function-item flex-rowc" @click="handleToast">
        <div class="auth-icon icon">
          <img src="../assets/images/auth-icon.png" alt="" />
        </div>
        <p>认证管理</p>
      </div>
      <div class="function-item flex-rowc" @click="logout">
        <div class="logout-icon icon">
          <img src="../assets/images/logout-icon.png" alt="" />
        </div>
        <p>退出登录状态</p>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Clipboard from "clipboard";
import { mapState } from "vuex";
import { updateUserInfo, uploadImage } from "../api/public";
export default {
  name: "Personal",
  data() {
    return {
      // 可添加数据
      PCA_address: "",
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {},
  methods: {
    // 触发 input 的点击事件
    handleClickUpload() {
      this.$refs.imageInput.click();
    },
    // 处理文件选择事件
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleChooseImg(file);
        // 清空 input 的值，以便下次选择相同文件时能触发 change 事件
        this.$refs.imageInput.value = "";
      }
    },
    // 修改用户头像
    async handleUpload(url) {
      const userInfo = this.$store.state.USERINFO;
      const params = {
        openid: userInfo.openid,
        headimg: url,
      };
      try {
        const res = await updateUserInfo(params);
        if (res.result) {
          // 等待 500 毫秒
          await new Promise((resolve) => setTimeout(resolve, 500));
          // 等待用户信息加载完成
          await this.$store.dispatch("fetchUserInfo", userInfo.openid);
        } else {
          this.$toast.fail(res.message || "头像更新失败");
        }
      } catch (error) {
        console.error("头像更新请求出错:", error);
        this.$toast.fail("头像更新失败，请稍后重试");
      }
    },
    // 上传图片
    async handleChooseImg(data) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      formData.append("imgfile", data);
      try {
        const res = await uploadImage(formData);
        if (res.result) {
          // 等待 500 毫秒
          await new Promise((resolve) => setTimeout(resolve, 500));
          await this.handleUpload(res.url);
        } else {
          this.$toast.fail(res.message || "上传失败");
        }
      } catch (error) {
        console.error("图片上传请求出错:", error);
        this.$toast.fail("上传失败，请稍后重试");
      } finally {
        toast.clear();
      }
    },

    //  编辑用户信息
    handleEditUser() {
      this.$router.push({ name: "UserEdit" });
    },

    handleToast() {
      this.$toast("即将开放");
    },
    // 退出登录
    logout() {
      this.$dialog
        .confirm({
          message: "是否退出登录",
        })
        .then(() => {
          // 清空本地存储
          // localStorage.clear();
          this.$store.commit("updateOpenid", "");
          this.$store.commit("updateUserInfo", "");
          this.$router.push("/");
        })
        .catch(() => {
          // on cancel
        });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
  
  <style scoped lang="less">
/* 可添加样式 */
.personal-page {
  padding: 80px 0 370px;
  box-sizing: border-box;
  .user-info {
    padding: 0 60px 0 55px;
    box-sizing: border-box;
    align-items: flex-start;
    .user-tx {
      width: 140px;
      height: 140px;
      box-sizing: border-box;
      border-radius: 50%;
      flex-shrink: 0;
      margin-right: 29px;
      position: relative;
      background: #f0f0f0;
      padding: 10px;
      img {
        width: 100%;
        height: 100%;
      }
      .edit-icon {
        position: absolute;
        width: 30px;
        height: 30px;
        background: #f0f0f0;
        right: 9px;
        bottom: 7px;
        border-radius: 50%;
        &::after {
          display: inline-block;
          content: "";
          width: 15px;
          height: 15px;
          background: url("../assets/images/edit-icon-tx.png") no-repeat center;
          background-size: cover;
        }
      }
    }
    .user-details {
      flex: 1;
      padding-top: 15px;
      box-sizing: border-box;
      .user-name {
        font-size: 30px;
        color: #3c3c3c;
        .edit-button {
          width: 20px;
          height: 20px;
          background: url("../assets/images/edit-icon.png") no-repeat center;
          background-size: cover;
          cursor: pointer;
        }
      }
      .user-level-job-number {
        font-size: 24px;
        color: #aaaaaa;
        margin: 12px 0 15px;
        .job-number {
          margin-left: 40px;
          .copy_box {
            width: 18px;
            height: 20px;
            background: url("../assets/images/copy-icon.png") no-repeat center;
            background-size: cover;
            margin-left: 13px;
          }
        }
        .level {
          p {
            &:nth-child(2) {
              margin: 0 10px;
            }
          }
        }
      }
      .user-verification {
        .txt {
          // width: 130px;
          height: 38px;
          background: #ff4200;
          border-radius: 18px;
          font-size: 22px;
          color: #fff;
          // padding-left: 18px;
          box-sizing: border-box;
          padding: 0 25px 0 18px;
          &::before {
            display: inline-block;
            content: "";
            width: 25px;
            height: 20px;
            background: url("../assets/images/vip-icon.png") no-repeat center;
            background-size: cover;
            margin-right: 12px;
          }
          &.disabled {
            background: #c8c8c8;
          }
        }
        .verify-button {
          width: 70px;
          height: 35px;
          background: #ffffff;
          border-radius: 18px;
          border: 1px solid #c8c8c8;
          margin-left: 10px;
          &::after {
            display: inline-block;
            content: "";
            width: 20px;
            height: 5px;
            background: url("../assets/images/more-icon.png") no-repeat center;
            background-size: cover;
          }
        }
      }
    }
  }
  .user-verification-info {
    margin: 54px 80px 80px;
    h1 {
      font-size: 30px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .user-verification-list {
      .user-verification-item {
        margin-bottom: 30px;

        &:last-child {
          align-items: flex-start;
        }
        .icon {
          width: 30px;
          height: 30px;
          margin-right: 13px;
          flex-shrink: 0;
          display: inline-block;
          &.weixin-icon {
            background: url("../assets/images/weixin-icon.png") no-repeat center;
            background-size: cover;
          }
          &.tel-icon {
            background: url("../assets/images/tel-icon.png") no-repeat center;
            background-size: cover;
          }
          &.sex-icon {
            background: url("../assets/images/sex-icon.png") no-repeat center;
            background-size: cover;
          }
          &.name-icon {
            background: url("../assets/images/name-icon.png") no-repeat center;
            background-size: cover;
          }
          &.age-icon {
            background: url("../assets/images/age-icon.png") no-repeat center;
            background-size: cover;
          }
          &.address-icon {
            background: url("../assets/images/address-icon.png") no-repeat
              center;
            background-size: cover;
          }
        }
        .info {
          font-size: 26px;
          color: #aaaaaa;
          h2 {
            flex-shrink: 0;
            font-size: 28px;
            color: #333333;
            // 占位为五个字符
            width: 5em;
            span {
              opacity: 0;
            }
          }
          .txt {
            margin-top: 25px;
            p {
              margin-bottom: 29px;
              &:last-child {
                margin-bottom: 0;
              }
            }
            input {
              width: 100%;
              background: none;
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
  .function-list {
    width: 600px;
    margin: auto;
    padding-top: 100px;
    .function-item {
      width: 100%;
      height: 90px;
      border: 1px solid #aaaaaa;
      border-radius: 45px;
      margin-bottom: 30px;
      box-sizing: border-box;
      font-size: 24px;
      color: #333333;
      background: #fff;
      padding: 0 30px 0 54px;
      cursor: pointer;
      .icon {
        img {
          height: 100%;
          width: 100%;
        }
      }
      .business-icon {
        width: 34px;
        height: 35px;
      }
      .auth-icon {
        width: 29px;
        height: 35px;
      }
      .logout-icon {
        width: 30px;
        height: 30px;
      }
      p {
        font-size: 30px;
        color: #333333;
        margin-left: 15px;
      }
    }
  }
}
</style>